import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo/logo.svg";
import ProductImage from "../components/ProductImage";
import PrimaryButton from "../components/PrimaryButton";
import FeatureCard from "../components/FeatureCard";
import BottomNavigation from "../components/BottomNavigation";
import { t } from "../services/i18n";
import { track } from "../services/analytics";

export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => { track("home_viewed"); }, []);

  return (
    <div className="page page--with-nav">
      <div className="center" style={{ padding: "12px 0" }}>
        <img src={logo} alt="Viraball" style={{ width: 132, height: "auto" }} />
      </div>
      <h1 className="h1">{t("home.title")}</h1>
      <p className="sub">{t("home.subtitle")}</p>
      <ProductImage />
      <PrimaryButton
        label={t("home.getStarted")}
        onClick={() => {
          track("onboarding_started");
          navigate("/getting-started");
        }}
      />
      <div className="feature-grid">
        <FeatureCard to="/getting-started" label={t("home.cards.howToUse")} icon={"\u24D8"} />
        <FeatureCard to="/modes" label={t("home.cards.modes")} icon={"\u223F"} />
        <FeatureCard to="/routine" label={t("home.cards.routine")} icon={"\u2713"} />
        <FeatureCard to="/help" label={t("home.cards.help")} icon={"?"} />
      </div>
      <p className="small-note">{t("home.noAccount")}</p>
      <BottomNavigation />
    </div>
  );
}
